<template>
  <div v-if="measKind!=='emeasure' && !isVital(measCcd)" class="icon-container">
    <!-- TODO: disable + for vitals -->
    <!-- if watching, should be able to remove -->
    <button  v-if="isMeasureInWatchList"
             @click.stop="removeMeasureFromWatch"
             class="icon__btn icon__btn--small icon--minus">
      <span>Trend −
        <!-- <font-awesome-icon icon="minus-circle" class="mr-md-2 mr-2 icon--minus" /> -->
      </span>
    </button>

    <!-- else, should be able to add -- >
    <button v-else-if="$trendFlag"
            class="icon__btn icon__btn--small icon--plus">
      <span>Trend +
        < !-- <font-awesome-icon icon="plus-circle" class="mr-md-2 mr-2 icon--plus" /> -- >
      </span>
    </button> -->

    <button  v-else
             @click.stop="addMeasureToWatch"
             class="icon__btn icon__btn--small icon--plus">
      <span>Trend +
        <!-- <font-awesome-icon icon="plus-circle" class="mr-md-2 mr-2 icon--plus" /> -->
      </span>
    </button>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { EventBus } from "../../../../event-bus";
  import router from '@/router/index';
  import { WatchNavigation } from '@/store/modules/fsm/messages';

  export default {
    name: "watch-measures",
    props: {
      procId: null,
      measId: null,
      procCcd: null,
      measCcd: null,
      measKind: null
    },
    computed: {
      ...mapGetters('login/watch', {
        measuresInWatchList: 'getMeasuresWatching',
        proceduresInWatchList: 'getProceduresWatching',
        vitalCcds: 'getVitalSignCodes'
      }),
      isMeasureInWatchList() {
        const watchList = (this.procCcd === null || typeof this.procCcd ==='undefined' )
          ? this.measuresInWatchList
          : this.proceduresInWatchList[this.procCcd];
          return watchList?watchList.hasOwnProperty(this.measCcd):false;
      }
    },
    data () {
      return {
        // isMeasureInWatchList: () => {
        //   // measure can come with or without proc
        //   const watchList = (this.procCcd === null)
        //   ? this.measuresInWatchList
        //   : this.proceduresInWatchList[this.procCcd];
        //   return watchList?watchList.hasOwnProperty(this.measCcd):false;
        // }
      }
    },
    methods: {
      ...mapActions('login/watch', [
        'addMeasure',
        'removeMeasure',
        'addTrendCheckedMeasure'
      ]),
      isVital(ccd) {
        return this.vitalCcds.includes(ccd);
      },
      async addMeasureToWatch() {
        if (this.isVital(this.measCcd)) return;
        let buttons = document.getElementsByClassName("icon__btn")
        for (let i = 0; i < buttons.length; i++){
          buttons[i].disabled = true
        }
        router.push({name:WatchNavigation, params: {procCcd: this.procCcd}})
        this.addMeasure({
          proc: this.procCcd, 
          meas: this.measCcd
        });
        await this.addTrendCheckedMeasure(this.measCcd)
      },
      async removeMeasureFromWatch() {
        await this.removeMeasure({proc: this.procCcd, meas: this.measCcd});
      },

    },

  }
</script>

<style scoped lang="scss">
  $color-base: #0060ff;

  .icon-container {
    margin-left: auto;
    position: relative;
    float: right;

    .icon__btn {
      color: white;
      border-radius: 20px;
      border: none;
      margin-top: 4px;
      padding: 0.3rem 0.9rem;
      line-height: 1.2;
      white-space: nowrap;
      font-size: 1.2rem;
    }

    .icon__btn--small {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      margin-left: 0;
      padding-top: 0.3rem;
      padding-bottom: 0.3rem;
      background-color: transparent;
      font-size: 1.0rem;
    }

    .icon--plus {
      background-color: $color-base;
      &:hover {
        cursor: pointer;
        background-color: darken($color-base, 20%);
      }
    }

    .icon--minus {
      background-color: #ff4444;
      &:hover {
        cursor: pointer;
        background-color: #cc0000;
      }
    }

  }
</style>
